import { useTranslation } from "react-i18next";
import { SocialLinks } from "@/components/SocialLinks";
import useSocialLinks from "@/lib/useSocialLinks";

export const DashboardFollowUs = () => {
  const { t } = useTranslation();
  const links = useSocialLinks();
  if (!links || !Object.values(links).some(Boolean)) return null;
  return (
    <div data-testid="dashboard-follow-us" className="bg-white border border-slate-200 rounded-2xl p-6 sm:p-8 flex flex-col md:flex-row md:items-center md:justify-between gap-5">
      <div>
        <div className="text-xs uppercase tracking-widest text-blue-800 font-semibold">{t("socialUi.eyebrow")}</div>
        <h3 className="mt-2 font-display font-bold text-xl text-slate-900">{t("socialUi.title")}</h3>
        <p className="mt-1 text-sm text-slate-600">{t("socialUi.body")}</p>
      </div>
      <SocialLinks testIdPrefix="dashboard-social-link" />
    </div>
  );
};
